import { QueryEngineView } from "modules/insights/types/entities";

export const insightsPrivateRoutesConstants = {
  root: {
    path: "/r/app/insights",
    href: () => "/r/app/insights"
  },
  query_engine: {
    path: "/r/app/insights/qe",
    href: (projectId: string, view?: QueryEngineView, id?: string) =>
      `/r/app/insights/qe?project=${projectId}${view ? `&view=${view}` : ""}${
        id ? `&query=${id}` : ""
      }`
  },
  project_stats: {
    path: "/r/app/insights/project_stats",
    href: (projectId: string) =>
      `/r/app/insights/project_stats?project=${projectId}`
  },
  roadmap: {
    path: "/r/app/insights/roadmap",
    href: (projectId: string) => `/r/app/insights/roadmap?project=${projectId}`
  },
  insights_repository: {
    path: "/r/app/insights/repository",
    href: (projectId: string) =>
      `/r/app/insights/repository?project=${projectId}`
  },
  single_insight: {
    path: "/r/app/insights/repository/:insightId",
    href: (projectId: string, insightId: number) =>
      `/r/app/insights/repository/${insightId}?project=${projectId}`
  }
} as const;
